<template>
	<article class="personalcenter_page">
		<header class="pages_title">
			<div class="backNav"></div>
			<div class="headertool_choosedate" @click="chooseJobDate">
				<div>
					<span>日期:</span>
					{{ currentDate }}
				</div>
			</div>
		</header>

		<section class="joblist_content">
			<div
				:class="['joblist_recordwrap', record.OrderState != 2 ? 'jobready' : 'jobover']"
				v-for="(record, index) in jobListData"
				:key="index"
				@click="showCurrentJobDetail(index)"
			>
				<div class="record_row">
					<div class="record_short">联系人：{{ record.Contact }}[{{ record.IsGo ? '去程' : '返程' }}]</div>
					<div class="record_short">
						电话：
						<a :href="['tel:' + record.riderPhone]">{{ record.riderPhone }}</a>
					</div>
				</div>

				<div class="record_row">
					<div class="record_short">人数：{{ record.MemberCount }}人</div>
					<div class="record_long">预约日期：{{ record.bookingDate }}</div>
				</div>

				<div class="record_row" @click.stop="showBaiduNav(index)">
					<div class="record_address">路线：[{{ record.StartDistrict }}]{{ record.bookingStartAddr }}-[{{ record.EndDistrict }}]{{ record.bookingEndAddr }}</div>
					<i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
				</div>

				<div class="record_row">
					<div class="record_short">行李件数：{{ record.LuggageCount }}</div>
					<div class="record_long">备注：{{ record.UserRemarks }}</div>
				</div>

				<!-- <div :class="['joblist_functionwrap', (currentJob && currentJob.ID && currentJob.ID === record.ID) ? 'functionshow' : 'functionshow']"> -->
				<div class="record_row">
					<div class="record_short" v-show="!record.IsFinish"><button @click="needSupport(record)">请求支援</button></div>
					<div class="record_long">
						<button @click="checkDriverArrive(record)" v-show="!record.IsArrive">到达指定地点</button>
						<button @click="checkOrderFinished(record)" v-show="!record.IsFinish">完成订单</button>
					</div>
				</div>
			</div>
		</section>

		<footer></footer>
	</article>
</template>

<script>
import { mapState } from 'vuex';
import driverApi from '@/request/driverApi';
import baseTool from '../utils/baseFunction';
export default {
	name: 'DriverJobList',
	data() {
		return {
			currentDate: '',
			jobDateList: [],
			jobListData: [],
			currentJob: null,
			showMask: false
		};
	},
	activated() {
		this.getJobDateList();
	},
	methods: {
		getJobDateList() {
			this.$Spin.show();
			driverApi.getJobDateList(this.OpenId).then(sucRes => {
				this.$Spin.hide();
				if (sucRes.success) {
					if (sucRes.data && sucRes.data.length > 0) {
						this.jobDateList = sucRes.data;
						this.currentDate = this.jobDateList[0].SetDate;
						this.getJobList(this.jobDateList[0].SetDate);
					} else {
						this.$Message.warning(sucRes.message);
					}
				} else alert(sucRes.message);
			});
		},
		getJobList(jobdate) {
			this.$Spin.show();
			this.jobListData = [];
			driverApi.getJobList(this.OpenId, jobdate).then(sucRes => {
				if (sucRes.success) {
					sucRes.data.forEach(val => {
						val.bookingDate = baseTool.formatDateStr(val.bookingDate, 'full');
						this.getJobSerivceLogList(val).then(returnVal => {
							val = returnVal;
							this.jobListData.push(val);
						});
					});
					// this.jobListData = sucRes.data;
					// console.log(this.jobListData);

					// this.jobListData.forEach(record => {
					// 	this.getJobSerivceLogList(record);
					// });
				}
				this.$Spin.hide();
			});
		},
		getJobSerivceLogList(jobModel) {
			return new Promise((resolve, reject) => {
				driverApi.getAppointServiceLogList(jobModel.OrderNum).then(sucRes => {
					jobModel.ServiceLogList = sucRes.data;
					jobModel.IsFinish = false;
					jobModel.IsArrive = false;
					sucRes.data.forEach(val => {
						if (val.LogType === 'OrderFinish') {
							jobModel.IsFinish = true;
						}
						if (val.LogType === 'DriverArrive') {
							jobModel.IsArrive = true;
						}
					});
					resolve(jobModel);
					// for (let i = 0; i < this.jobListData.length; i++) {
					// 	if (this.jobListData[i].OrderNum === jobModel.OrderNum) {
					// 		this.$nextTick(() => {
					// 			this.jobListData[i] = jobModel;
					// 		});
					// 		break;
					// 	}
					// }
				});
			});
		},
		chooseJobDate() {
			let that = this;
			let tmpArray = [];
			for (let i = 0; i < this.jobDateList.length; i++) {
				let tmp = {
					label: this.jobDateList[i].SetDate,
					value: this.jobDateList[i].SetDate
				};
				tmpArray.push(tmp);
			}
			this.$weui.picker(tmpArray, {
				onConfirm(result) {
					that.currentDate = result[0].value;
					that.getJobList(that.currentDate);
				}
			});
		},
		showCurrentJobDetail(currentIndex) {
			let that = this;
			if (currentIndex < this.jobListData.length) {
				this.currentJob = this.jobListData[currentIndex];
			}
		},
		showBaiduNav(index) {
			let model = this.jobListData[index];
			let url = `https://api.map.baidu.com/direction?origin=${model.bookingStartAddr}&destination=${
				model.bookingEndAddr
			}&mode=driving&region=中山&output=html&src=webapp.baidu.openAPIdemo`;
			window.open(url);
		},
		needSupport(record) {
			let logType = 'DriverLate';
			this.getJobSerivceLogList(record).then(resultRecord => {
				let noRecord = true;
				if (resultRecord.ServiceLogList && resultRecord.ServiceLogList.length && resultRecord.ServiceLogList.length > 0) {
					for (let i = 0; i < resultRecord.ServiceLogList.length; i++) {
						if (resultRecord.ServiceLogList[i].LogType === logType) noRecord = false;
					}
				}
				if (noRecord) {
					this.sendServiceLog(logType, record, sucRes => {}, () => {});
				} else {
					this.$Message.warning('已发送过迟到通知，正等待处理！');
				}
			});
		},
		checkDriverArrive(record) {
			let logType = 'DriverArrive';
			this.getJobSerivceLogList(record).then(resultRecord => {
				let noRecord = true;
				if (resultRecord.ServiceLogList && resultRecord.ServiceLogList.length && resultRecord.ServiceLogList.length > 0) {
					for (let i = 0; i < resultRecord.ServiceLogList.length; i++) {
						if (resultRecord.ServiceLogList[i].LogType === logType) noRecord = false;
					}
				}
				if (noRecord) {
					this.sendServiceLog(logType, record, sucRes => {}, () => {});
				} else {
					this.$Message.warning('已发送过到达通知！');
				}
			});
		},
		checkOrderFinished(record) {
			let logType = 'OrderFinish';
			this.sendServiceLog(
				logType,
				record,
				sucRes => {
					this.getJobSerivceLogList(record).then(newRecord => {
						for (let i = 0; i < this.jobListData.length; i++) {
							if (this.jobListData[i].OrderNum === newRecord.OrderNum) {
								this.jobListData[i] = newRecord;
							}
						}
					});
				},
				() => {}
			);
		},
		sendServiceLog(logType, record, sucCallback, failCallback) {
			this.getNowLocation().then(location => {
				driverApi.makeAppointServiceLog(this.OpenId, logType, record.OrderNum, location).then(sucRes => {
					if (sucRes.success) {
						this.$Message.success(sucRes.message);
						if (sucCallback) sucCallback(sucRes);
					} else {
						this.$Message.warning(sucRes.message);
						if (failCallback) failCallback();
					}
				});
			});
		},
		getNowLocation() {
			return new Promise((resolve, reject) => {
				wx.getLocation({
					type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
					success: res => {
						let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
						let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
						let speed = res.speed; // 速度，以米/每秒计
						let accuracy = res.accuracy; // 位置精度
						// that.$store.commit('user/setLocation', longitude + ',' + latitude);
						console.log(res);
						resolve(longitude + ',' + latitude);
					},
					fail: failRes => {
						console.log(failRes);
						reject(failRes);
					}
				});
			});
		}
	},
	computed: mapState({
		OpenId: state => state.user.OpenId
		// OpenId: state => 'oDcOv532-NFdzWgPZkmKHt5WySDo'
	})
};
</script>

<style lang="less" scoped>
@import '../style/public';
@import '../style/variable';

.joblist_content {
	width: 100%;
	height: 90vh;
	overflow: scroll;
	display: -webkit-flex;
	display: flex;
	-webkit-flex-direction: column;
	flex-direction: column;
	flex-wrap: nowrap;

	// flex-flow: column||nowrap;

	.joblist_recordwrap {
		padding-left: 3px;
		padding-right: 3px;
		padding-top: 2px;
		padding-bottom: 2px;
		// bottom: 5px;
		border: 2px solid black;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-direction: column;
		flex-direction: column;
		margin: 5px;
		// background-color: lightyellow;

		.record_row {
			width: 100%;
			height: auto;
			flex-wrap: nowrap;
			display: -webkit-flex;
			display: flex;
			-webkit-flex-direction: row;
			flex-direction: row;
			justify-content: flex-start;
			border: 2px solid wheat;
		}

		.record_short {
			display: flex;
			height: 100%;
			flex-direction: row;
			flex-wrap: nowrap;
			flex: 1;
		}

		.record_long {
			display: flex;
			height: 100%;
			flex-direction: row;
			flex-wrap: nowrap;
			flex: 2;
		}

		.joblist_functionwrap {
			// flex: 0 0 100% !important;
			border-top: 1px solid #888;
			line-height: 4vh;
			// height: 0;
			overflow: hidden;
			transition: all 0.3s;
			height: 4vh !important;
		}
		joblist_functionwrap.functionshow {
			height: 4vh !important;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/DriverJobList.vue